import React from 'react';
type Props = {
	src: string;
	dataId?: string;
	usermediaCdn: string;
	width?: number | string;
	height?: number | string;
	dataPrice?: string;
	className?: any
	onClick?: any
	style?: any,
}
const Image = ({ src, width, height, className, onClick, style, dataId, dataPrice, usermediaCdn }: Props) => {
	const finalSrc = src.startsWith('https://') ? src : usermediaCdn + src
	return (
		<div
			style={{
				backgroundImage: `url(${finalSrc})`,
				backgroundSize: 'contain',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center center',
				width,
				height,
				borderRadius: 10,
				overflow: 'hidden',
				...style,
			}}
			data-id={dataId}
			data-price={dataPrice}
			className={className}
			onClick={e => (onClick ? onClick(e) : null)}
		/>
	);
};

export default Image;
